import { useCashDownField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const DefaultCashDownRow = () => {
    const { label, inputProps } = useCashDownField();
    const inputId = useScenarioCellId('cashDown');

    return (
        <ScenarioRow rowKey="cashDown" label={label} inputId={inputId}>
            <NumericInput {...inputProps} id={inputId} displayLabel={false} />
        </ScenarioRow>
    );
};
